/* eslint-disable import/prefer-default-export */
import irelandApi from '../irelandApi';
import {
  GET_BLU_BAR_BRANDS_FULFILLED,
  GET_BLU_BAR_BRANDS_PENDING,
  GET_BLU_BAR_BRANDS_REJECTED,
  GET_HOME_PAGE_BRANDS_FULFILLED,
  GET_HOME_PAGE_BRANDS_PENDING,
  GET_HOME_PAGE_BRANDS_REJECTED,
  GET_BRANDS_USER_FULFILLED,
  GET_BRANDS_USER_PENDING,
  GET_BRANDS_USER_REJECTED
} from '../reducers/brandsUserReducer';

export const getBrandsUser = () => (dispatch) => {
  dispatch({ type: GET_BRANDS_USER_PENDING, payload: [] });

  return irelandApi
    .get('/api/brands')
    .then((response) => {
      const payload = response.data ? response.data : { data: false };
      dispatch({ type: GET_BRANDS_USER_FULFILLED, payLoad: payload });
    })
    .catch((error) => {
      dispatch({ type: GET_BRANDS_USER_REJECTED, payLoad: error });
    });
};

export const getHomePageBrands = () => (dispatch) => {
  dispatch({ type: GET_HOME_PAGE_BRANDS_PENDING });

  return irelandApi
    .get('/api/brands/home_page_brands')
    .then((response) => {
      dispatch({ type: GET_HOME_PAGE_BRANDS_FULFILLED, payLoad: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_HOME_PAGE_BRANDS_REJECTED, payLoad: error });
    });
};


export const getBluBarBrands = () => (dispatch) => {
  dispatch({ type: GET_BLU_BAR_BRANDS_PENDING });

  return irelandApi
    .get('/api/brands/blu_bar_brands')
    .then((response) => {
      dispatch({ type: GET_BLU_BAR_BRANDS_FULFILLED, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_BLU_BAR_BRANDS_REJECTED, payload: error });
    });
};
